import {useQuery} from '@tanstack/react-query'
import {AgendaExternaService} from '@services'
import {agendaExternaKeys} from './query-keys'
import type {Identificador} from '../types'

interface ParametrosParceirosQuery {
  isFornecedor: boolean | null
  codigoUsuario: Identificador | null
}

export function useParceirosQuery({isFornecedor, codigoUsuario}: ParametrosParceirosQuery) {
  const agendaExternaService = AgendaExternaService()

  return useQuery({
    queryKey: agendaExternaKeys.parceiros(isFornecedor ?? false, codigoUsuario ?? ''),
    queryFn: async () => {
      if (codigoUsuario === null) {
        return []
      }

      const {data} = isFornecedor === true
        ? await agendaExternaService.getTransports(codigoUsuario)
        : await agendaExternaService.getSupplier()

      return data
    },
    enabled: codigoUsuario !== null,
  })
}
